import React from 'react';
import { useQuery } from 'react-query';
import { layoffService } from '_services';
import LayoffModal from './LayoffModal';
import PdfDocument from './PdfDocument';
import styles from './layoff.module.scss';

/**
 * Discharge form preview, prefilled for one employee when given
 */
const PreviewModal = ({ isOpen, employee, onClose }) => {
  const {
    data: file,
    isLoading,
    isError,
  } = useQuery(
    ['layoffs', 'preview', employee?.hash ?? 'blank'],
    () => layoffService.getPreview(employee?.hash),
    { enabled: isOpen, staleTime: 60 * 1000 },
  );

  return (
    <LayoffModal
      isOpen={isOpen}
      title={`Preview: discharge form${employee ? ` for ${employee.name}` : ''}`}
      onClose={onClose}
      wide
    >
      <p className={styles.hint}>
        The Superintendent fills in the lay-off effective date and their part of
        the form when they sign. The employee then signs.
      </p>
      {isLoading && <p>Loading preview...</p>}
      {isError && <p>The preview could not be loaded. Please try again.</p>}
      {file && <PdfDocument file={file} />}
    </LayoffModal>
  );
};

export default PreviewModal;
